import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import Frame from "../chrome/Frame";
import Seo from "../chrome/Seo";

const NotFound = () => (
  <Frame>
    <Seo title="Not found" />
    <div className="lost">
      <div>
        <div className="figure">4<em>0</em>4</div>
        <h2>This route does not exist.</h2>
        <p style={{ color: "#5a626e", maxWidth: 480, margin: "0 auto 2rem" }}>
          The page you were looking for has either moved or was never published.
        </p>
        <Link to="/" className="btn btn--ink">
          Return to home <FiArrowRight />
        </Link>
      </div>
    </div>
  </Frame>
);

export default NotFound;
